<template>
  <div>

  </div>
</template>

<script>
export default {
  data(){
    return{

    }
  },
  mounted(){
    if(this.$route.query.lang == 'en'){
      this.$i18n.locale = 'en';
      window.localStorage.setItem('localeLanguage', this.$i18n.locale)
      this.$store.state.lan = this.$i18n.locale
      this.$router.push({name: 'Login'})
    }
    if(this.$route.query.lang == 'zh'){
      this.$i18n.locale = 'zh';
      window.localStorage.setItem('localeLanguage', this.$i18n.locale)
      this.$store.state.lan = this.$i18n.locale
      this.$router.push({name: 'Login'})
    }
    if(this.$route.query.lang == 'jp'){
      this.$i18n.locale = 'jp';
      window.localStorage.setItem('localeLanguage', this.$i18n.locale)
      this.$store.state.lan = this.$i18n.locale
      this.$router.push({name: 'Login'})
    }
  },
}
</script>